import {
  List,
  Datagrid,
  TextField,
  Filter,
  SelectInput,
  TextInput,
  DateField,
} from "react-admin";
import { exporter } from "../utils";
import { ListPagination } from "../../../utils";
import CustomActions from "../../../components/CustomActions";

const FeedbackFilter = (props) => (
  <Filter {...props}>
    <TextInput label="Amostra" source="sample.name" alwaysOn />
    <TextInput label="Laboratório" source="lab.name" alwaysOn />
    <SelectInput
      label="Tipo"
      source="typeRate.name"
      choices={[
        { id: "modulation", name: "Modulação" },
        { id: "comment", name: "Comentário" },
      ]}
    />
  </Filter>
);

const FeedbackList = (props) => (
  <List
    bulkActionButtons={<div />}
    {...props}
    perPage={25}
    title="Lista de Feedbacks"
    actions={<CustomActions />}
    exporter={exporter}
    filters={<FeedbackFilter />}
    sort={{ field: "createdAt", order: "DESC" }}
    pagination={<ListPagination />}
  >
    <Datagrid rowClick="edit">
      <TextField label="Ciclo" source="cycleId" />
      <TextField sortable={false} label="Usuário (Documento)" source="user.document" />
      <TextField sortable={false} label="Amostra" source="sample.name" />
      <TextField sortable={false}label="Tipo" source="typeRate.name" />
      <TextField label="Resposta" source="value" />
      <TextField sortable={false} label="Laboratório" source="sample.lab.name" />
      <DateField label="Data de Criação" source="createdAt" />
    </Datagrid>
  </List>
);

export default FeedbackList;
